import React from 'react';

/**
 * <EmptyState /> — a successful load with nothing in it. Say what's missing and
 * offer the next step; it's an invitation to act, never a dead end.
 *
 *   <EmptyState icon="fa-solid fa-briefcase" title="No jobs yet"
 *     body="Jobs you create or are invited to appear here."
 *     action={<button className="cw-btn cw-btn-primary" onClick={openNew}>New job</button>} />
 *
 * @param {string} [icon]        Font Awesome class
 * @param {ReactNode} title
 * @param {ReactNode} [body]
 * @param {ReactNode} [action]   a button/link (or use actionLabel + onAction)
 * @param {string} [actionLabel]
 * @param {()=>void} [onAction]
 * @param {boolean} [compact]    for inside cards and table bodies
 */
const EmptyState = ({ icon = 'fa-regular fa-folder-open', title, body, action, actionLabel, onAction, compact = false, className = '' }) => (
  <div className={`cw-empty${compact ? ' compact' : ''} ${className}`.trim()}>
    {icon && <span className="cw-empty-ico" aria-hidden="true"><i className={icon} /></span>}
    {title && <p className="cw-empty-title">{title}</p>}
    {body && <p className="cw-empty-body">{body}</p>}
    {(action || (actionLabel && onAction)) && (
      <div className="cw-empty-action">
        {action || <button type="button" className="cw-btn cw-btn-primary" onClick={onAction}>{actionLabel}</button>}
      </div>
    )}
  </div>
);

export default EmptyState;
